require('./main.css');
require('./loading-bar.css');
// require('./wellbe.css');
require('./fonts.css');
require('./font-awesome/css/font-awesome.min.css');